import { configureStore } from "@reduxjs/toolkit";
import * as storage from "./storage";

const store = configureStore({
  reducer: {
    storage: storage.reducer,
  },
});

export default store;

export type StateDispatch = typeof store.dispatch;
export type State = ReturnType<typeof store.getState>;
